import axios from 'axios';
import { GET_BILLING_SEARCH_SUGGESTIONS } from '../../../constants/api';

const SEARCH_BY_POLICY_NUMBER = 'policyNumber';
const SEARCH_BY_ACCOUNT_NUMBER = 'accountNumber';
const SEARCH_BY_INSURED_NAME = 'insuredName';

const billingSearchCriteriaMenuItems = [
  {
    value: SEARCH_BY_POLICY_NUMBER,
    label: 'Policy Number',
  },
  {
    value: SEARCH_BY_ACCOUNT_NUMBER,
    label: 'Account Number',
  },
  {
    value: SEARCH_BY_INSURED_NAME,
    label: 'Insured Name',
  },
];

const insuredNameSearchRadioOptions = [
  {
    value: 'exact',
    label: 'Exact',
  },
  {
    value: 'contains',
    label: 'Contains',
  },
];

const fetchPolicyNumberFormSuggestions = async (params) => {
  const formsData = await axios.get(GET_BILLING_SEARCH_SUGGESTIONS, { params: { billing_name_type: 'policy_number', search_value: params.searchValue } });
  const formsSuggestion = formsData.data;
  return formsSuggestion;
};

const fetchAccountNumberFormSuggestions = async (params) => {
  const formsData = await axios.get(GET_BILLING_SEARCH_SUGGESTIONS, { params: { billing_name_type: 'account_number', search_value: params.searchValue } });
  const formsSuggestion = formsData.data;
  return formsSuggestion;
};

const fetchInsuredNameFormSuggestions = async (params) => {
  const formsData = await axios.get(GET_BILLING_SEARCH_SUGGESTIONS, { params: { billing_name_type: 'insured_last_name', search_value: params.searchValue } });
  const formsSuggestion = formsData.data;
  return formsSuggestion;
};

const getInvalidText = (property, value) => {
  const trimmedValue = value.trim();
  const trimmedValueLength = trimmedValue.length;
  switch (property) {
    case SEARCH_BY_POLICY_NUMBER:
      return trimmedValueLength >= 3 ? '' : 'Full policy number is required';
    case SEARCH_BY_ACCOUNT_NUMBER:
      return trimmedValueLength >= 3 ? '' : 'Full account number is required';
    case SEARCH_BY_INSURED_NAME:
      return trimmedValueLength > 0 ? '' : 'Insured name is required';
    default:
      return '';
  }
};

export {
  billingSearchCriteriaMenuItems,
  fetchAccountNumberFormSuggestions,
  fetchInsuredNameFormSuggestions,
  fetchPolicyNumberFormSuggestions,
  getInvalidText,
  insuredNameSearchRadioOptions,
  SEARCH_BY_ACCOUNT_NUMBER,
  SEARCH_BY_INSURED_NAME,
  SEARCH_BY_POLICY_NUMBER,
};
